import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';

import { MODALS } from 'global-constants';

import WithUser from 'shared/HOCs/WithUser';
import { fetchMe } from 'shared/HOCs/FetchInitials/ducks/index.js';

import LoadMoreView from 'shared/components/LoadMoreView';
import { openModal } from 'shared/components/Modals/reducer';
import InfluencerLine from 'shared/components/InfluencerLine';

import NoTeamMembers from './NoTeamMembers';

import styles from './styles.module.scss';

class TeamMembers extends React.Component {
  componentDidMount() {
    this.props.fetchTeamMembers();
  }

  componentDidUpdate(prevProps) {
    if (_.isNil(prevProps.user) && this.props.user) {
      this.props.fetchTeamMembers();
    }
  }

  handleMessageUnsignedClick = () => {
    if (_.isEmpty(this.props.user)) {
      this.props.openModal({ modalName: MODALS.SIGNUP });
    }
  };

  render() {
    const {
      user,
      team,
      teamMembersNext,
      companyName,
      isInvestor,
      isServiceProvider,
      withTitle = true
    } = this.props;

    return (
      <div className={styles.wrapper}>
        {withTitle && <div className={styles.title}>Team Members</div>}
        <LoadMoreView
          loadMore={() => this.props.fetchNextTeamMembers(teamMembersNext)}
          hasMore={!_.isNil(teamMembersNext)}
          isLoading={this.props.isFetchingTeam}
          loader={<InfluencerLine.Placeholder count={10} />}>
          {!_.isEmpty(team) ? (
            team.map(
              (influencer, index) =>
                influencer.profile && (
                  <InfluencerLine
                    key={influencer.slug}
                    className={styles.influencerBox}
                    isSameUser={user && influencer.id === user.id}
                    influencer={influencer}
                    handleMessageUnsignedClick={this.handleMessageUnsignedClick}
                  />
                )
            )
          ) : (
            <NoTeamMembers
              companyName={companyName}
              isServiceProvider={isServiceProvider}
              isInvestor={isInvestor}
            />
          )}
        </LoadMoreView>
      </div>
    );
  }
}

export default WithUser(
  connect(
    null,
    { openModal, fetchMe }
  )(TeamMembers)
);
